/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgApplications = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18 13v3h3v2h-3v3h-2v-3h-3v-2h3v-3zm-7 0v8H3v-8zm-2 2H5v4h4zm2-12v8H3V3zm10 0v8h-8V3zM9 5H5v4l4-.001zm9.999 0H15v3.999h3.999z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgApplications as Applications };
